/* eslint-disable max-len */
import { variableCategories } from './pm.sharedModel.constants';

/**
 * @typedef {Object} endnote - UI viewmodel
 * @property {string} type - [Req'd by Token] Type of token which is always "pm-endnote"
 * @property {string} tag - [Req'd by Token] Database unique identifier, ex.: "Important_Info"
 *
 * @property {string} note - The content of the endnote, ex.: "This is some important extra info."
 * @property {string} policyDocumentEndNoteId - ex.: 2
 * @property {string} policyDocumentId - ex.: 2
 * @property {Array<Object>} sections - List of sections that use this endnote
 */

/**
 * @typedef {Object} policyDocumentEndNote - API model
 * @property {string} createdDate - ex.: "2019-05-07T15:39:19.187"
 * @property {string} CreatedUserId - ex.: 1
 * @property {string} deletedDate - ex.: null
 * @property {string} deletedUserId - ex.: null
 * @property {string} note - The content of the endnote, ex.: "This is some important extra info."
 * @property {string} policyDocumentEndNoteId - ex.: 2
 * @property {string} policyDocumentId - ex.: 2
 * @property {string} tag - Database unique identifier, ex.: "Important_Info"
 */

/**
 * @typedef {Object} variable - UI viewmodel
 * @property {string} type - [Req'd by Token] Type of token which is always "pm-variable"
 * @property {string} tag - [Req'd by Token] Database unique identifier, ex.: "IT_Committee_Name"
 * @property {string} displayName - [Req'd by Token] The token's visible label, ex.: "IT Committee Name"
 */

export default class pmSharedModelTransformations {
  /**
   *
   * @param {Array<policyDocumentEndNote>} policyDocumentEndNotes
   * @return {Array<endnote>}
   */
  static transformPolicyDocumentEndNotesToEndnotes(policyDocumentEndNotes) {
    const endnotes = policyDocumentEndNotes;
    policyDocumentEndNotes.forEach((item) => {
      item.type = 'pm-endnote';
      // if (!item.tag) {
      //   item.displayName = item.tag.replace(/_/g, ' ');
      // }
    });
    return endnotes;
  }

  /**
   *
   * @param {endnote} endnote
   * @return {policyDocumentEndNote}
   */
  static transformEndnoteToPolicyDocumentEndNote(endnote) {
    const policyDocumentEndNote = {
      ...endnote,
      // tag: pmSharedModelTransformations.transformEndnoteDisplayNameToTag(endnote.displayName)
    };
    // This property is not used by the API
    delete policyDocumentEndNote.type;
    // Never send this property as it may break child relationships
    delete policyDocumentEndNote.policyDocumentSections;
    return policyDocumentEndNote;
  }

  static transformEndnoteDisplayNameToTag(displayName) {
    return displayName.replace(/\s/g, '_');
  }

  /**
   *
   * @param {Array<policyDocumentVariable>} policyDocumentVariables
   * @return {Array<variable>}
   */
  static transformPolicyDocumentVariablesToVariables(policyDocumentVariables) {
    const variables = policyDocumentVariables;
    policyDocumentVariables.forEach((item) => {
      item.type = 'pm-variable';
    });
    return variables;
  }

  static getNewEndnote(policyDocumentId) {
    return {
      note: '',
      policyDocumentEndNoteId: -1,
      policyDocumentId,
      policyDocumentSections: [],
      tag: '',
      type: 'pm-endnote',
    };
  }

  static transformPolicyDocumentVariablesWithCategory(policyDocumentVariables) {
    console.log(variableCategories);
    policyDocumentVariables.forEach((variable) => {
      for (const key in variableCategories) { // eslint-disable-line no-restricted-syntax
        if (variable.name === key) {
          variable.category = variableCategories[key];
          return variable;
        }
      }
      return variable;
    });
    return policyDocumentVariables;
  }
}
